import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

export async function confirmDelete(label: string, detail?: string) {
  const result = await Swal.fire({
    icon: "warning",
    title: "¿Confirmás la eliminación?",
    html: `<strong>${escapeHtml(label)}</strong><br><small>${escapeHtml(detail || "Esta acción no se puede deshacer.")}</small>`,
    showCancelButton: true,
    confirmButtonText: "Sí, eliminar",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#c13f49",
    cancelButtonColor: "#708090",
    reverseButtons: true,
    focusCancel: true,
  });
  return result.isConfirmed;
}

export async function deleteFailed(error: unknown, fallback = "No se pudo eliminar el registro") {
  await Swal.fire({
    icon: "error",
    title: "No se pudo eliminar",
    text: error instanceof Error ? error.message : fallback,
    confirmButtonText: "Entendido",
    confirmButtonColor: "#169c98",
  });
}

function escapeHtml(value: string) {
  return value.replace(/[&<>'"]/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[character] || character);
}
